import { LeaderboardsHomePage } from "@ugg/shared/components/Leaderboards/LeaderboardsHomePage";
import { RampLeftRail, RampRightRail } from "components/Ads/RampRails";
import { MediaQuery } from "@outplayed/responsive";

export function LeaderboardsPage() {
  return (
    <div className="flex justify-center mx-auto w-full max-md:w-full">
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 mr-[-12px]">
          <RampLeftRail className="sticky top-[calc(var(--masthead-height)+100px)] transition-[top]" />
        </div>
      </MediaQuery>
      <div className="content-side-padding w-[1016px] mx-auto pt-[24px] box-content max-md:w-full max-md:box-border">
        <LeaderboardsHomePage />
      </div>
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 ml-[-12px]">
          <RampRightRail className="sticky top-[calc(var(--masthead-height)+100px)] transition-[top]" />
        </div>
      </MediaQuery>
    </div>
  );
}
